import { useContext, useEffect, useCallback, Suspense } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useIntl } from 'react-intl';

// Hooks
import { useAuth } from '@/hooks/useAuth';

// Assets
import logo from '../../assets/img/logo-pepsico-h.svg';

// Components
import Header from '@/components/organisms/Header/Header';
import ErrorBoundary from '@/components/ErrorBoundary';
import { LoadingSpinner } from 'pepsico-ds';

// import {Header} from '@/components/organisms'
import { Alert, SidebarMenu } from '@/components/molecules';
import { HeaderExtraItems } from './components/HeaderExtraItems';

// Context
import { AuthContext } from '@/context/Auth/AuthContext';
import { isFeatureEnabled } from '@/helpers/featureToggle';

// Constants
import { FeatureToggle } from '@/utils/constants/featuresFlag';

// Redux
import { useAppDispatch, useAppSelector } from '@/store';
import {
  resetToastNotifications,
  selectShellActive
} from '@/store/slices/commonSlice';
import { selectDarkMode } from '@/store/slices/themeSlice';
import {
  selectShellPath,
  setShellPath
} from '@/store/slices/commonSlice';

export const Template = ({ children }) => {
  const { isAuthenticated } = useAuth()
  return isAuthenticated ? (
    <Logged>{children}</Logged>
  ) : (
    <NotLogged />
  );
};

const Logged = props => {
  const { show, type, message } = useAppSelector(state => state.notifications);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const darkMode = useAppSelector(selectDarkMode);
  const shellActive = useAppSelector(selectShellActive);
  const shellPath = useAppSelector(selectShellPath)
  const { pathname, search } = useLocation();
  const { formatMessage } = useIntl();

  const onCloseAlert = useCallback(() => {
    // store.dispatch(resetNotifications())
  }, []);

  useEffect(() => {
    // important: immediately navigate to shellPath received from the top shell & reset it
    if (shellPath) {
      navigate(shellPath)
      dispatch(setShellPath(''))
    }
  }, [shellPath, navigate, dispatch])

  return (
    <ErrorBoundary>
      {!shellActive && (
        // <Header
        //   logo={logo}
        //   title={formatMessage({ id: 'GENERAL.HEADER_TITLE' })}>
        //   <Suspense fallback={<LoadingSpinner size='small' />}>
        //     <HeaderExtraItems />
        //   </Suspense>
        // </Header>
        <Header
          logo={logo}
          title={"B2B Profile Management"}>
          <Suspense fallback={<LoadingSpinner size='small' />}>
            <HeaderExtraItems />
          </Suspense>
        </Header>
      )}
      <div
        data-testid='content'
        className='relative flex h-full max-h-[calc(100vh-4rem)]'>
        {!shellActive && <SidebarMenu />}
        <main
          data-testid='content-main'
          data-cy='content-main'
          className={`${darkMode ? 'dark-mode' : ''} ${
            shellActive ? 'm-0' : 'ml-20 pl-8'
          } w-full overflow-auto bg-background pb-6 pr-6 pt-7 text-zinc-800`}
          {...props}
        />
        <Alert
          data-cy='feedback-alert'
          type={type}
          message={message}
          show={show}
          onCloseClick={onCloseAlert}
        />
      </div>
    </ErrorBoundary>
  );
};

const NotLogged = () => {
  const { handleLogin } = useAuth();
  const { pathname, search } = useLocation();

  useEffect(() => {
    localStorage.setItem('previousPath', pathname + search);
    handleLogin('redirect');
  }, [pathname, search, handleLogin]);

  return null;
};
